import fsl_agents from '../../assets/images/fls_agents.svg'
import copilot from '../../assets/images/copilot.svg'
import styles from './UnderMaintenance.module.scss'
import {APPLY_FORM_URL} from "../../constants.tsx";
import {openLink} from "@telegram-apps/sdk";


export default function UnderMaintenance() {
    return (
        <div className={styles.soonPage}>
            <img className={styles.img} src={fsl_agents} alt='' />
            <img className={styles.img} src={copilot} alt='' />
            <h2 className={styles.title}>Health Co-pilot is coming!<br/>Apply to the Closed Beta</h2>
            <button
                className={styles.button}
                onClick={() => {
                    openLink(APPLY_FORM_URL, {
                        tryBrowser: 'chrome',
                        tryInstantView: true,
                    });
                }}
            >
                APPLY
            </button>
        </div>
    )
}
